import { meshSelectionStore } from '../../Mesh/State/MeshSelectionStore';

export const getVersionGenealogy = (modifications, currentVersionId) => {
    if (!modifications || modifications.length === 0) {
        return [];
    }

    const versionsByIndex = new Map();
    const versionIdToIndex = new Map();

    modifications.forEach((mod, index) => {
        const normalizedVersion = {
            id: index,
            versionNumber: index + 1,
            movementHistory: mod.movementHistory || {},
            parentVersion: mod.parentVersion,
            deleted: !!mod.deleted,
            author: mod.author,
            lastUpdate: mod.lastUpdate,
            modificationId: mod.id
        };

        versionsByIndex.set(index, normalizedVersion);

        if (mod && mod.id !== undefined && mod.id !== null && mod.id !== -2) {
            versionIdToIndex.set(mod.id, index);
        }
    });

    const resolveParentIndex = (parentVersion) => {
        if (parentVersion === null || parentVersion === undefined || parentVersion === -1) {
            return null;
        }

        if (versionsByIndex.has(parentVersion)) {
            return parentVersion;
        }

        if (versionIdToIndex.has(parentVersion)) {
            return versionIdToIndex.get(parentVersion);
        }

        return null;
    };

    const buildGenealogy = (versionIndex) => {
        const result = [];
        let currentIndex = versionIndex;
        const visited = new Set();

        while (currentIndex !== null && currentIndex !== undefined && versionsByIndex.has(currentIndex) && !visited.has(currentIndex)) {
            visited.add(currentIndex);
            const version = versionsByIndex.get(currentIndex);
            result.push(version);
            currentIndex = resolveParentIndex(version.parentVersion);
        }

        return result;
    };

    return buildGenealogy(currentVersionId);
};

export const getVersionMovementHistory = (modifications, versionId) => {
    if (!modifications || versionId === -1) {
        return {};
    }

    const versionIndex = versionId;
    if (modifications[versionIndex]) {
        return modifications[versionIndex].movementHistory || {};
    }

    return {};
};

export const getAllMovementsForTooth = (genealogy, toothId) => {
    const movements = [];

    genealogy.forEach((version) => {
        const toothMovements = version.movementHistory[toothId];
        if (toothMovements) {
            movements.push({
                versionNumber: version.versionNumber,
                author: version.author,
                lastUpdate: version.lastUpdate,
                movements: toothMovements
            });
        }
    });

    return movements;
};

export const hasMovementHistory = (modifications, versionId) => {
    if (!modifications || versionId === -1) {
        return false;
    }

    const versionIndex = versionId;
    const version = modifications[versionIndex];
    if (!version) return false;

    const movementHistory = version.movementHistory;
    if (movementHistory && Object.keys(movementHistory).length > 0) {
        return true;
    }

    return version.parentVersion !== undefined && version.parentVersion !== null;
};

export const getCurrentModifications = () => {
    return meshSelectionStore.getModifications();
};
